// document.querySelectorAll('.ctm-btn').forEach(button => {
//   button.addEventListener('click', function (e) {
//     e.preventDefault();
    
//     const targetId = this.getAttribute('href');
//     const target = document.querySelector(targetId);
    
//     if (target) {
//       window.scrollTo({
//         top: target.offsetTop,
//         behavior: 'smooth'
//       });
//     }
//   });
// });


document.addEventListener("DOMContentLoaded", function() {
  var selectEl = document.querySelector("[name='id']"); // Shopify's variant dropdown
  var descItems = document.querySelectorAll(".variant-description-item");

  function updateDescription(variantId) {
    descItems.forEach(function(item) {
      item.style.display = (item.dataset.variantId === variantId) ? "block" : "none";
    });
  }

  // Initial load
  if (selectEl) {
    updateDescription(selectEl.value);

    // On change
    selectEl.addEventListener("change", function() {
      updateDescription(this.value);
    });
  }
});
